<template>
  <div class="login-page">
    <div class="login-wrapper">
      <h2 class="login-title" :style="{ color: colorsGeneralPrimary }">
        Acceso
      </h2>
      <form @submit.prevent>
        <label>
          <span :style="{ color: colorsGeneralPrimary }">E-Mail</span>
          <input
            class="email"
            type="email"
            v-model.trim="email"
            placeholder="email@email.com"
          />
        </label>

        <label>
          <span :style="{ color: colorsGeneralPrimary }">Password</span>
          <input
            class="password"
            type="password"
            @keyup.enter="login"
            v-model.trim="password"
            placeholder="******"
          />
        </label>
        <router-link to="recover-password">Recuperar password</router-link>
        <button
          type="submit"
          class="submit"
          @click="login"
          :style="adminSubmitTheme"
        >
          Entrar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebaseConfig";
import { getUserById } from "@/collections/users";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    login() {
      auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(async user => {
          user = auth.currentUser;
          this.$store.commit("setCurrentUser", user);

          this.$store.commit("setCurrentUser", user);
          this.$store.commit("setUserProfile", await getUserById(user.uid));
          this.$router.push("/admin");
        })
        .catch(error => {
          let message =
            error.code === "auth/wrong-password"
              ? "Contraseña erronea"
              : "Email o contraseña erronea";

          this.showErrorMessage(message);
          this.setlogError(
            "login_user",
            message,
            error.stack,
            this.$options.name
          );
          this.$router.push("/admin");
        });
    }
  }
};
</script>
